<template>
  <div id="header">
    <v-app-bar absolute color="#6A76AB" dark flat style="z-index: 999;">
      <router-link to="/" style="text-decoration: none; color: inherit;">
        <v-toolbar-title>PosterDay</v-toolbar-title>
      </router-link>

      <v-spacer></v-spacer>

      <v-flex class="mr-12" justify-center style="maxWidth: 500px;">
        <v-text-field
          v-model="searchTerm"
          hide-details
          prepend-icon="mdi-magnify"
          single-line
          label="Search"
          @focus="overlay = true"
          @blur="overlay = false"
          @keydown.enter="searchExecute"
        ></v-text-field>
      </v-flex>
      <!-- <v-btn>Search</v-btn> -->

      <Sign v-if="$store.state.user == null" />
      <div v-else>
        <v-btn @click="signOut">
          Sign Out
        </v-btn>

        <v-menu
          v-model="menu"
          transition="slide-y-transition"
          :close-on-content-click="false"
          :nudge-width="200"
          :offset-y="true"
          offset-x
        >
          <template v-slot:activator="{ on }">
            <button v-on="on">
              <v-badge
                class="mx-8"
                :content="notifications"
                :value="notifications"
                color="red"
                overlap
                v-on="on"
              >
                <v-icon>mdi-account-circle</v-icon>
              </v-badge>
            </button>
          </template>

          <v-card>
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <img
                    src="https://cdn.vuetifyjs.com/images/john.jpg"
                    alt="John"
                  />
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>John Leider</v-list-item-title>
                  <v-list-item-subtitle
                    >Founder of Vuetify.js</v-list-item-subtitle
                  >
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    :class="fav ? 'red--text' : ''"
                    icon
                    @click="fav = !fav"
                  >
                    <v-icon>mdi-heart</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list>
              <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="message" color="purple"></v-switch>
                </v-list-item-action>
                <v-list-item-title>Enable messages</v-list-item-title>
              </v-list-item>

              <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="hints" color="purple"></v-switch>
                </v-list-item-action>
                <v-list-item-title>Enable hints</v-list-item-title>
              </v-list-item>
            </v-list>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn text @click="menu = false">Cancel</v-btn>
              <v-btn color="primary" text @click="menu = false">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </div>
    </v-app-bar>
    <v-overlay :value="overlay">
      <!-- <v-btn class="white--text" color="teal" @click="overlay = false">
        Hide Overlay
      </v-btn> -->
    </v-overlay>
  </div>
</template>

<script>
import Sign from "./Sign";

export default {
  name: "Header",
  components: { Sign },
  data() {
    return {
      isLoggedIn: true,
      currentUser: false,
      notifications: 10,
      fav: true,
      menu: false,
      message: false,
      hints: true,
      overlay: false,
      searchTerm: "",
    };
  },
  methods: {
    signOut() {
      this.$store.dispatch("signOutAction");
    },
    searchExecute() {
      this.overlay = false;
      this.searchTerm = "";
      this.$router.push("search");
    },
  },
};
</script>

<style lang="scss" scoped>
.v-toolbar__title {
  font-family: "Playfair Display";
  font-weight: 600;
  font-size: 1.5rem;
}
</style>
